//Libs
import styled from "styled-components";
import { DatePicker as _DatePicker } from "antd";

const DatePicker = styled(_DatePicker)`
  width: ${(props) => props.width ?? props.theme.datePicker.width};
`;

export default DatePicker;
